import { render, staticRenderFns } from "./PurposesRentingAreasAddEditModal.vue?vue&type=template&id=20215a7e&scoped=true&"
import script from "./PurposesRentingAreasAddEditModal.vue?vue&type=script&lang=js&"
export * from "./PurposesRentingAreasAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20215a7e",
  null
  
)

export default component.exports